export const formatUSCurrency = (amount) => {
    if (isNaN(amount) || amount === null || amount === undefined) {
        return "$0.00"; // Default value if amount is invalid
      }
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(amount);
  };